import { render, staticRenderFns } from "./FqaDictEdit.vue?vue&type=template&id=59a56b0a&"
import script from "./FqaDictEdit.vue?vue&type=script&lang=js&"
export * from "./FqaDictEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports